import { PageHero } from "@/components/site/PageHero";
import { ContactBlock } from "@/components/site/ContactBlock";
import { Marquee } from "@/components/site/Marquee";

export default function Contact() {
  return (
    <div data-testid="page-view-contact">
      <PageHero testId="contact-hero" eyebrow="Contact" lines={["Day or night,", <>we <span className="font-serif-i font-normal tracking-normal text-sky-300">answer.</span></>]}
        intro="Call our 24/7 line or send an enquiry below. A coordinator — not a call centre — will get back to you." />
      <ContactBlock />
      <Marquee />
    </div>
  );
}
